// (c) 2026 Owl Consultations. All rights reserved.
// D-CRX-23: the shared specialty badge (patients screen, home dashboard, future mounts).
// Purple = drug_reference-classified Specialty/REMS; amber = CareRx formulary-book match only
// (upgrades automatically as Andrew's red-line loads).

export type SpecialtyFlag = { specialty: boolean; formulary_match: boolean; sample_drug: string | null }

export default function SpecialtyBadge({ flag }: { flag?: SpecialtyFlag }) {
  if (!flag) return null
  return (
    <span title={flag.sample_drug ?? undefined} style={{
      fontSize: 10, fontWeight: 700, letterSpacing: .3, textTransform: 'uppercase',
      padding: '1px 7px', borderRadius: 999, whiteSpace: 'nowrap',
      background: flag.specialty ? '#f3e8ff' : '#fffbeb',
      color: flag.specialty ? '#7c3aed' : '#92400e',
      border: `1px solid ${flag.specialty ? '#a855f7' : '#d97706'}`,
    }}>Specialty</span>
  )
}
